import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ActionIcon, Button, Flex, Text } from "@mantine/core";
import { AppModal } from "./AppModal";
import { Loop } from "@mui/icons-material";
import { useState } from "react";
import { useResetPasswordMutation } from "../graphql/graphql";
import { generatePassword } from "../utils/Password.utils";
import { CopyButton } from "./CopyComponents/CopyButton";
import { showErrorNotification, showSuccessNotification } from "./Notifications";
export const ResetPasswordModal = ({ userId, email, opened, close }) => {
    const [tempPassword, setTempPassword] = useState(generatePassword());
    const [{ fetching }, resetPassword] = useResetPasswordMutation();
    const submitResetPassword = async () => {
        await resetPassword({
            userIdToReset: userId,
            temporaryPassword: tempPassword
        })
            .then(() => {
            showSuccessNotification("Password reset successful!");
        })
            .catch((error) => {
            console.error("An error occurred.", error);
            showErrorNotification("There was an error resetting the password.");
        })
            .finally(() => {
            handleClose();
        });
    };
    const getGeneratedPassword = () => {
        return generatePassword({
            length: 10,
            includeNumbers: true,
            includeSpecialCharacters: true
        });
    };
    const handleClose = () => {
        setTempPassword("");
        close();
    };
    return (_jsxs(AppModal, { title: "Reset Password", opened: opened, onClose: handleClose, children: [_jsxs(Flex, { gap: "sm", align: "center", mb: 10, children: [_jsx(Text, { variant: "body", size: "xs", children: "Reset password for:" }), _jsx(Text, { variant: "body", fw: 900, children: email })] }), _jsxs(Flex, { gap: "sm", align: "center", mb: 20, children: [_jsx(Text, { variant: "body", size: "xs", children: "Temporary password:" }), _jsx(Text, { variant: "body", fw: 900, children: tempPassword }), _jsxs(Flex, { style: {
                            gap: "0.5rem",
                            marginLeft: "auto",
                            marginRight: "1rem",
                            alignItems: "center"
                        }, children: [_jsx(CopyButton, { value: tempPassword }), _jsx(ActionIcon, { variant: "filled", onClick: () => setTempPassword(getGeneratedPassword()), children: _jsx(Loop, { fontSize: "inherit" }) })] })] }), _jsx(Flex, { justify: "flex-end", children: _jsx(Button, { variant: "filled", loading: fetching, onClick: submitResetPassword, children: "Reset Password" }) })] }));
};
